<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

// ADDED by MADEV d070825 to exclude certain vendors from Brand filters -->
document.addEventListener('DOMContentLoaded', function () {
  const isCollectionPage = window.location.pathname.includes('/collections/');
  const isSearchPage = window.location.pathname.includes('/search');

  if (!(isCollectionPage || isSearchPage)) return;

  const excludedVendors = ["F4NTEC", "Airstrike", "Bless My Sole®", "So God Made A Farmer®" ];

  const hideUnwantedVendorFilters = () => {
    document.querySelectorAll('label.facet-checkbox').forEach(label => {
      const labelText = label.childNodes[0]?.textContent?.trim()?.toLowerCase();
      if (labelText) {
        excludedVendors.forEach(vendor => {
          if (labelText === vendor.toLowerCase()) {
            const parentItem = label.closest('li.facets__item');
            if (parentItem) parentItem.remove();
          }
        });
      }
    });
  };

  hideUnwantedVendorFilters();
  document.addEventListener('shopify:section:load', hideUnwantedVendorFilters);
  setTimeout(hideUnwantedVendorFilters, 1000);
});

// ADDED by MADEV d081325 to remove the 15% offer from the Wholesale Inquiry page -->

document.addEventListener("DOMContentLoaded", function() {
    if (window.location.pathname === "/pages/become-a-kerusso-retailer") {
        const hidePsWidget = () => {
            const widget = document.getElementById("ps__widget_container");
            if (widget) {
                widget.style.display = "none";
            }
        };

        // Run once in case it's already loaded
        hidePsWidget();

        // Watch for dynamically inserted elements
        const observer = new MutationObserver(hidePsWidget);
        observer.observe(document.body, { childList: true, subtree: true });
    }
});


// ADDED by MADEV d082025 to show cursor in search bar -->

document.addEventListener('DOMContentLoaded', function () {
  //
  // === DESKTOP: header quick-search modal ===
  //
  const desktopDetails = document.querySelector('.search_details--popup');
  const desktopInput = document.getElementById('Search-In-Modal-Menu-Plain');

  if (desktopDetails && desktopInput) {
    desktopDetails.addEventListener('toggle', function () {
      if (desktopDetails.open) {
        setTimeout(function () {
          desktopInput.value = '';
          desktopInput.focus();
        }, 100); // allow modal DOM/animation to settle
      }
    });
  }
  
  // === MOBILE: halo-sidebar-search slide-out (no Liquid changes) ===
  //
  const mobileInput = document.getElementById('Search-In-Modal-Sidebar');
  const isMobile = () => window.matchMedia('(max-width: 749px)').matches;

  // We can’t rely on editing markup, so use broad, safe selectors
  // for the header search triggers that open mobile search.
  const SEARCH_TRIGGER_SELECTOR = [
    // common Ella/halo search icon/button hooks
    '.header__icon--search',
    '[data-search-menu]',
    '[data-search-menu-sticky-form]',
    '[data-action="open-search"]',
    '.search-link',
    '.search-toggle',
    '.site-header__search',
  ].join(',');

  // Delegate click/tap so it's a true user gesture (mobile requires this)
  document.addEventListener('click', function (e) {
    if (!isMobile() || !mobileInput) return;

    const trigger = e.target.closest(SEARCH_TRIGGER_SELECTOR);
    if (!trigger) return;

    // 1) Immediate focus in the same click handler (unblocks mobile keyboard)
    mobileInput.value = '';
    mobileInput.focus();

    // 2) Follow-up focus after sidebar animation completes
    //    (adjust delay if your slide-in uses a different duration)
    setTimeout(function () {
      mobileInput.focus();
    }, 350);
  });

  // Optional: repeat focus once more if the slide-out is slower on some devices
  // (keeps desktop untouched; still tied to the user's initial click)
  document.addEventListener('click', function (e) {
    if (!isMobile() || !mobileInput) return;

    const trigger = e.target.closest(SEARCH_TRIGGER_SELECTOR);
    if (!trigger) return;

    setTimeout(function () {
      mobileInput.focus();
    }, 650);
  });
});
